import { useState, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const useContacts = () => {
  const { baseUrl, userID, basicAuth, chatContacts, setChatContacts } = useContext(GlobalContext);

  const headers = {
  Authorization: basicAuth,
  "Content-Type": "application/json",
};

  const [contacts, setContacts] = useState([]);
  const [audience, setAudience] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchChatContacts = async (pageIndex = 1, recordPerPage = 50) => {
    try {
      setLoading(true);

      const res = await fetch(`${baseUrl}/Campaign/v1.0/getContacts`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          userid: userID,
          pageIndex: pageIndex.toString(),
          recordPerPage: recordPerPage.toString(),
        }),
      });

      const data = await res.json();

      if (data?.data) {
        setChatContacts((prev) =>
          pageIndex === 1 ? data.data : [...prev, ...data.data],
        );
      }

      return data;
    } catch (err) {
      console.error("Chat Contacts Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const searchChatContacts = async (searchText) => {
    try {
      const res = await fetch(`${baseUrl}/Campaign/v2.0/getContacts`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          userid: userID,
          searchText,
        }),
      });

      const data = await res.json();

      if (data?.data) {
        setChatContacts(data.data);
      }
    } catch (err) {
      console.error("Search Contacts Error:", err);
    }
  };

  const fetchAudience = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/LeadManagement/getAudienceGroup`,
        { userid: userID },
        { headers ,}
      );

      if (response.data.responseCode === "00") {
        setAudience(response.data.data);
      }
    } catch (error) {
      console.error("Audience Error:", error);
    }
  };

  const addContact = async (payload) => {
    try {
      const response = await fetch(`${baseUrl}/Campaign/addContact`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          userid: userID,
          ...payload,
        }),
      });

      return await response.json();
    } catch (error) {
      console.error("Add Contact Error:", error);

      throw error;
    }
  };

  const uploadBulkContacts = async (contacts) => {
    try {
      const response = await axios.post(
        `${baseUrl}/Campaign/uploadBulkContact`,
        { contacts },
          {headers},
      );

      return response.data;
    } catch (error) {
      console.error("Bulk Upload Error:", error);

      throw error;
    }
  };

  const deleteContact = async (contactNumber) => {
    try {
      const response = await fetch(`${baseUrl}/Campaign/deleteContact`, {
        method: "POST",
        headers,
         body: JSON.stringify({
        userid: userID,
        contactNumber: contactNumber,
      }),
      });

      return await response.json();
    } catch (error) {
      console.error("Delete Contact Error:", error);

      throw error;
    }
  };

  return {
    contacts,
    chatContacts,
    audience,
    loading,

    fetchChatContacts,
    searchChatContacts,
    fetchAudience,

    addContact,
    uploadBulkContacts,
    deleteContact,

    setContacts,
    setChatContacts,
  };
};

export default useContacts;
